import { render } from "./indexwork.vue?vue&type=template&id=60e14f74"
import script from "./indexwork.vue?vue&type=script&lang=js"
export * from "./indexwork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__